<div class="modal-header mb-4" *ngIf="!chatSelected && !messagesLoading; else chatHeaderDetail">
    <h5 class="modal-title fw-bold my-auto" id="exampleModalLabel">Historial de chats</h5>
    <button type="button" class="p-0 m-0 d-flex my-auto close" (click)="closeDialog()">
        <img src="./assets/img/times.svg" width="18">
    </button>
</div>
<ng-template #chatHeaderDetail>
    <div class="modal-header mb-4 d-flex justify-content-between">
        <div class="d-flex back-history-list my-auto" role="button" (click)="chatSelected = null; messagesLoading = false; chatParentSelected = null">
            <i-feather name="arrow-left" class="d-flex my-auto"></i-feather>
            <span class="d-flex my-auto">Volver al listado</span>
        </div>
        <button type="button" class="p-0 m-0 d-flex my-auto close" (click)="closeDialog()">
            <img src="./assets/img/times.svg" width="18">
        </button>
        <!-- <i-feather name="arrow-left" role="button" (click)="chatSelected = null" style="height: 18px; width: 18px;"></i-feather> -->
        <!-- <button mat-flat-button (click)="chatSelected = null" style="background-color: black; color: white; border-radius: 25px; font-size: 12px;width: 35px;height: 25px;">Volver</button> -->
    </div>
</ng-template>

<div class="modal-body">
    <div class="container m-0 p-0">
        <div class="row m-0">
            <div class="col-12 p-0 text-center py-4" *ngIf="chatsLoading">
                <img src="assets/img/loader.svg" width="60" height="60" alt="Cargando"/>
            </div>
            <div class="col-12 p-0" *ngIf="!chatsLoading && chats.length === 0">
                No hay chats archivados
            </div>
            <div class="col-12 p-0 modal-content-wrapper" *ngIf="!chatsLoading && chats.length > 0">
                <ng-container *ngIf="!chatSelected && !messagesLoading; else chatDetail">
                    <div class="row m-0 chat-item" *ngFor="let chat of chats" (click)="openChatHistory(chat)">
                        <div class="col-10 p-0">
                            <div class="row m-0" style="row-gap: 4px;">
                                <div class="col-12 p-0 sender">
                                    <span>
                                        {{ chat.distributor_name }}
                                    </span>
                                </div>
                                <div class="col-12 p-0 msg-text">
                                    {{ chat.last_message_text }}
                                </div>
                            </div>
                        </div>
                        <div class="col-2 p-0 d-flex justify-content-end my-auto msg-date">
                            {{ chat.last_message_date }}
                         
                        </div>
                    </div>
                </ng-container>
                <ng-template #chatDetail>
                    <div class="row m-0" *ngIf="chatParentSelected != null">
                        <div class="col-12 p-0 d-flex mb-2 justify-content-center chat-detail-header">
                            <span class="chat-title">Chat</span>
                            <span class="my-auto chat-badge" *ngIf="chatParentSelected.distributor_name">
                                <span class="my-auto">{{ chatParentSelected.distributor_name }}</span>
                                <img src="./assets/img/info_white.svg" ngbTooltip="Distribuidor" class="img-fluid ico-title icon-white my-auto" width="16">
                            </span>
                            <!-- <span class="my-auto chat-badge" *ngIf="chatSelected.gpvName">
                                <span class="my-auto">{{ chatSelected.gpvName }}</span>
                                <img src="./assets/img/info_white.svg" ngbTooltip="GPV" class="img-fluid ico-title icon-white my-auto" width="16">
                            </span> -->
                        </div>
                    </div>
                    <div class="row m-0 text-center py-4" *ngIf="messagesLoading">
                        <img src="assets/img/loader.svg" width="60" height="60" alt="Cargando"/>
                    </div>
                    <div class="row m-0 chat-lines" *ngIf="!messagesLoading && chatSelected?.length > 0">
                        <div class="col-12 p-0 chat-line" *ngFor="let chat of chatSelected; index as i" >
                            <div *ngIf="chat.separator" class="divider-with-text" [ngStyle]="{'margin-top': i === 0 ? '0' : '16px' }">
                                {{ chat.separator }}
                            </div>
                                 
                            <div *ngIf="!chat.separator" class="row m-0">
                                <div class="col-12 p-0" [ngStyle]="{'margin-bottom': (i < chatSelected.length - 1 && chatSelected[i+1].sender_id !== chat.sender_id) ? '16px' : '4px'}" >
                                    <div class="row m-0" style="gap: 4px;">
                                        <div class="col-12 p-0 chat-line-header">
                                            <span class="chat-sender" *ngIf="i === 0 || chatSelected[i-1].sender_id !== chat.sender_id">[{{ chat.name }}]</span>
                                            <!-- <span class="my-auto chat-time my-auto">{{ msg.msgTime | date: 'hh:mm' }}</span> -->
                                        </div>
                                        <div class="col-12 p-0 chat-line-text">
                                            <div class="row m-0 d-flex">
                                                <div class="col-10 p-0">
                                                    <div class="a-center" *ngIf="chat.file_status == 'pending'">
                                                        <img src="./assets/img/loader.svg" width="60" alt="" height="60">
                                                    </div>

                                                    <div *ngIf="chat.file_status != 'pending' && chat.file_url && chat.file_is_image" class="chat-attachment-image" style="margin-bottom: 5px;">
                                                        <a [href]="chat.file_url" target="_blank" class="chat-img" [style.background-image]="'url(' + chat.file_url + ')'"></a>
                                                    </div>

                                                    <div *ngIf="chat.file_status != 'pending' && chat.file_url && !chat.file_is_image">
                                                        <a class="file-link" [href]="chat.file_url" download>
                                                            <i-feather name="file"></i-feather>
                                                            <span>{{ chat.file_name }}</span>
                                                        </a>
                                                    </div>

                                                    <div *ngIf="chat.text && chat.text != ''">{{ chat.text }}</div>
                                                </div>
                                                <div class="col-2 p-0 d-flex justify-content-end">
                                                    <span class="my-auto chat-time my-auto">{{ chat.time }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
